import { render } from "./TrainingAssessement.vue?vue&type=template&id=23d25715"
import script from "./TrainingAssessement.vue?vue&type=script&lang=js"
export * from "./TrainingAssessement.vue?vue&type=script&lang=js"

import exportComponent from "/Users/macbookpro/Herd/hris-laravel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__